<template>
	<div id="app">
		<!-- 需要缓存的视图组件 -->
		<keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
		<!--这里是不会被缓存的组件-->
		<router-view v-if="!$route.meta.keepAlive && isRouterAlive" ></router-view>
		<van-tabbar v-model="active" route placeholder active-color="#0EC9AC" v-show="$route.meta.isShowTabbar" style="height: 85px;">
			<van-tabbar-item to="/index" >
				<span>诊疗首页</span><template #icon="props"><van-icon name="wap-home" size="30" /></template>
			</van-tabbar-item>
			<van-tabbar-item to="/openModule" >
				<span>院内服务</span><template #icon="props"><van-icon name="search" size="30" /></template>
			</van-tabbar-item>
			<van-tabbar-item to="/personalCenter" >
				<span>个人中心</span><template #icon="props"><van-icon name="manager" size="30" /></template>
			</van-tabbar-item>
		</van-tabbar>
		<!-- 悬浮球 -->
		<FloatBall v-if="!$route.meta.isHidFloatBall"></FloatBall>
	</div>
</template>

<script>
import FloatBall from '@/components/FloatBall';
export default {
	name: 'App',
	data() {
		return {
			active: 0,
      isRouterAlive: true
		};
	},
	components: { FloatBall },
	created() {},
  provide () {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入。
    return {
      reload: this.reload
    };
  },
	mounted() {
		// var system = {};
		// //获取运行浏览器的操作系统和（或）硬件平台
		// var p = navigator.platform;
		// //获取浏览器信息
		// var u = navigator.userAgent;
		// system.win = p.indexOf('Win') == 0;
		// system.mac = p.indexOf('Mac') == 0;
		// system.x11 = p == 'X11' || p.indexOf('Linux') == 0;
		// if (system.win || system.mac || system.xll) {
		// 	let flag = u.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
		// 	if (flag) {
		// 		//手机端;放行
		// 	} else {
		// 		//PC端;此时跳转
		// 		this.$router.push({
		// 			path: '/CommonError/当前设备非手机端，请在手机端操作'
		// 		});
		// 	}
		// }
	},
  methods: {
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
@import url('assets/css/common.css');
body,
html {
	background-color: #f2f3f5;
}
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* text-align: center; */
	background-color: #f2f3f5;
	
}
.van-tabbar-item__text {
	font-size: 15px;
}
</style>
